import React from 'react';
import StatisticScoreCard from './StatisticScoreCard.jsx';

const score = (val) =>
  typeof val === 'number' && !Number.isNaN(val) ? val : null;

const KEY_TO_ENGNAME = {
  climate_score: 'climate',
  water_score: 'water',
  biodiversity_score: 'biodiversity',
  transport_score: 'transport',
  land_use_score: 'land_use',
  fertilizers_use_score: 'fertilizer_use',
  pesticides_use_score: 'pesticide_use',
  health_score: 'health',
  antibiotics_resistance_score: 'antibiotics_resistance',
  social_justice_score: 'social_justice',
  child_labor_score: 'child_labor',
  animal_protection_score: 'world_animal_protection',
  worker_rights_score: 'worker_rights',
  equality_score: 'equality',
  local_population_score: 'local_population',
};

const groupDefs = [
  {
    key: 'environment',
    title: 'Miljö',
    items: [
      { key: 'climate_score', label: 'Klimat' },
      { key: 'water_score', label: 'Vatten' },
      { key: 'biodiversity_score', label: 'Biologisk mångfald' },
      { key: 'transport_score', label: 'Transport' },
      { key: 'land_use_score', label: 'Landanvändning' },
      { key: 'fertilizers_use_score', label: 'Övergödning' },
      { key: 'pesticides_use_score', label: 'Bekämpningsmedel' },
    ],
  },
  {
    key: 'health',
    title: 'Hälsa',
    items: [
      { key: 'health_score', label: 'Hälsa' },
      { key: 'antibiotics_resistance_score', label: 'Antibiotikaresistens' },
    ],
  },
  {
    key: 'social',
    title: 'Rättvisa',
    items: [
      { key: 'social_justice_score', label: 'Social rättvisa' },
      { key: 'child_labor_score', label: 'Barnarbete' },
      { key: 'animal_protection_score', label: 'Djurvälfärd' },
      { key: 'worker_rights_score', label: 'Arbetsförhållanden' },
      { key: 'equality_score', label: 'Jämlikhet' },
      { key: 'local_population_score', label: 'Lokalbefolkning' },
    ],
  },
];

export function buildStatistics(dish) {
  return groupDefs.map((group) => {
    const categories = group.items.map((it) => ({
      name: it.label,
      engName: KEY_TO_ENGNAME[it.key] ?? it.key.replace(/_score$/, ''),
      score: score(dish[it.key]) ?? null,
      bonus: dish[`${it.key}_bonus`] ?? null,
    }));
    const iconSrc =
      group.title === 'Miljö'
        ? '/assets/icons/svg/Miljo.svg'
        : group.title === 'Hälsa'
          ? '/assets/icons/svg/Halsa.svg'
          : '/assets/icons/svg/Rattvisa.svg';
    return {
      title: group.title,
      categories,
      iconSrc,
      color: '#9CD7B6',
    };
  });
}

export function buildAverageScores(dish) {
  const envItems = groupDefs.find((g) => g.key === 'environment').items;
  const healthItems = groupDefs.find((g) => g.key === 'health').items;
  const socialItems = groupDefs.find((g) => g.key === 'social').items;

  const envValues = envItems
    .map((it) => score(dish[it.key]))
    .filter((v) => v != null && v > 0);
  const envAvg =
    envValues.length > 0
      ? Math.round(envValues.reduce((a, b) => a + b, 0) / envValues.length)
      : 0;

  const healthValues = healthItems
    .filter((it) => it.key === 'health_score')
    .map((it) => score(dish[it.key]))
    .filter((v) => v != null);
  const healthAvg =
    healthValues.length > 0
      ? Math.round(healthValues.reduce((a, b) => a + b, 0) / healthValues.length)
      : 0;

  const socialValues = socialItems
    .map((it) => score(dish[it.key]))
    .filter((v) => v != null && v > 0);
  const socialAvg =
    socialValues.length > 0
      ? Math.round(socialValues.reduce((a, b) => a + b, 0) / socialValues.length)
      : 0;

  return {
    environment: envAvg,
    health: healthAvg,
    social: socialAvg,
  };
}

const ParametersGroups = ({ dish, darkMode = false, t = null, productId }) => {
  if (!dish) return null;

  const statistics = buildStatistics(dish);
  const average_scores = buildAverageScores(dish);
  const translate = typeof t === 'function' ? t : (x) => x;

  return (
    <div className="grid grid-cols-1 tablet:grid-cols-3 laptop:grid-cols-3 desktop:grid-cols-3 gap-[18px]">
      {statistics.map((statistic, index) => (
        <div
          key={index}
          className="min-w-0"
        >
          <StatisticScoreCard
            title={statistic.title}
            categories={statistic.categories}
            iconSrc={statistic.iconSrc}
            color={statistic.color}
            productId={productId ?? dish?.gtin ?? null}
            average_scores={average_scores}
            t={translate}
          />
        </div>
      ))}
    </div>
  );
};

export default ParametersGroups;
